import { SearchRounded } from '@mui/icons-material';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import { useState } from 'react';
import { useDebounce } from 'react-use';

interface ManageUnifiedFieldsSearchInputProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export const ManageUnifiedFieldsSearchInput = ({
  searchValue,
  setSearchValue,
}: ManageUnifiedFieldsSearchInputProps) => {
  const [input, setInput] = useState('');

  useDebounce(
    () => {
      setSearchValue(input);
    },
    250,
    [input],
  );

  return (
    <FormControl sx={{ width: 600 }}>
      <OutlinedInput
        size="small"
        id="search-unified-fields"
        placeholder="Search Unified Fields"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <SearchRounded />
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
